import { DatepickerHeading } from '@/components/AgGrid/components/CustomDateComponent';
import { Col, DatePicker, Form } from 'antd';
import type { IField } from '../data';
import styles from '../styles.less';

const { Item } = Form;

// DatePicker date formats
export const dateFormatList = ['DD/MM/YYYY', 'D/M/YYYY', 'DD-MM-YYYY', 'D-M-YYYY', 'DD.MM.YYYY', 'D.M.YYYY'];

const Datepicker: React.FC<IField> = (props) => {
    const {
        name,
        span = 8,
        label,
        rules,
        tooltip,
        placeholder,
        disabled,
        onChange,
        disabledDate,
        placement = 'bottomLeft',
        onOpenChange,
        showTime = false,
        xs,
        lg,
        marginBottom = 0,
        inputReadOnly,
        hidden,
        allowClear = true,
        panelRender: customPanelRender,
        t,
        value,
    } = props;

    const grid = {
        xs: xs || span,
        lg: lg || span,
        span: span,
    };

    const styling = {
        style: marginBottom ? { marginBottom } : {},
    };

    return (
        <Col key={name} {...grid}>
            <Item label={t?.(label)} name={name} rules={rules} {...styling} hidden={hidden} tooltip={tooltip}>
                <DatePicker
                    placeholder={t?.(placeholder)}
                    disabled={disabled}
                    className={styles.fullWidth}
                    disabledDate={disabledDate}
                    showTime={showTime}
                    inputReadOnly={inputReadOnly}
                    onChange={onChange}
                    placement={placement}
                    value={value}
                    getPopupContainer={(trigger: HTMLElement) => {
                        return trigger.parentElement || trigger;
                    }}
                    panelRender={(originPanel: React.ReactNode) => {
                        if (!!customPanelRender) {
                            return customPanelRender(originPanel);
                        }
                        return <DatepickerHeading originPanel={originPanel} />;
                    }}
                    allowClear={allowClear}
                    format={dateFormatList}
                    onOpenChange={onOpenChange}
                />
            </Item>
        </Col>
    );
};

export default Datepicker;
